<template>
    <span
        class="inline-flex items-center justify-center border px-2 py-0.5 text-[10px] font-medium leading-[10px] tracking-[-0.24px]"
        :class="badgeClass"
    >
        {{ label }}
    </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
    status: 'active' | 'inactive';
}>();

const label = computed(() => (props.status === 'active' ? 'Active' : 'Inactive'));

const badgeClass = computed(() =>
    props.status === 'active'
        ? 'border-success bg-surface-success text-success'
        : 'border-new-red-500 bg-new-red-100 text-new-red-500',
);
</script>
